export const ACCESS_EXPIRED_MESSAGE = 'Access expired.' as const;

export type LoginRedirect =
  | { kind: 'accountBlockedExpired' }
  | { kind: 'auth0LinkExpired'; message: string }
  | { kind: 'unblockSuccess' }
  | { kind: 'none' };

export function parseLoginRedirect(query: Record<string, string | string[] | undefined>): LoginRedirect {
  const { success, message, redirectFromBlockEmail } = query;

  if (redirectFromBlockEmail === 'true' && message === ACCESS_EXPIRED_MESSAGE && success === 'false') {
    return { kind: 'accountBlockedExpired' };
  }
  if (success === 'true' && !!redirectFromBlockEmail) {
    return { kind: 'unblockSuccess' };
  }
  if (typeof message === 'string' && success === 'false') {
    return { kind: 'auth0LinkExpired', message };
  }
  return { kind: 'none' };
}
